import * as React from 'react';

import type Organisation from 'benchmarking-domain/organisation';
import { authClient } from 'lib/auth/client';
import { logger } from 'lib/default-logger';
import {useUser} from "../hooks/use-user";
import {useCallback} from "react";

export interface OrganisationContextValue {
  organisationId?: string;
  setOrganisationId: (organisationId: string | undefined) => void;
}

export const OrganisationContext = React.createContext<OrganisationContextValue | undefined>(undefined);

export interface OrganisationProviderProps {
  children: React.ReactNode;
}

export function OrganisationProvider({ children }: OrganisationProviderProps): React.JSX.Element {

  const { user, error, isLoading } = useUser();
  const [state, setState] = React.useState<{ organisationId?: string}>(() =>{

    if(user)
    {
      const localStorageValue = window.localStorage.getItem('sessionOrganisationId');
      if(localStorageValue && (user.organisationIds && user.organisationIds?.indexOf(localStorageValue) > -1 || user.roles?.some(r => r === "superAdmin")))
      {
        return {organisationId: localStorageValue};
      }
      else
      {
        return {organisationId: user.organisationIds?.[0]};
      }
    }

    return {organisationId: undefined};
  });

  const setOrganisationId = useCallback((organisationId: string | undefined) => {
    setState({...state, organisationId});

    if(organisationId) {
      window.localStorage.setItem('sessionOrganisationId', organisationId);
    } else {
      window.localStorage.removeItem('sessionOrganisationId');
    }
  }, [state]);

  return <OrganisationContext.Provider value={{ ...state, setOrganisationId }}>{children}</OrganisationContext.Provider>;
}

export const OrganisationConsumer = OrganisationContext.Consumer;
